import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import Calculators from "@/components/Calculators";
import Timeline from "@/components/Timeline";
import Guides from "@/components/Guides";
import Marquee from "@/components/Marquee";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";
import GuidePage from "@/components/GuidePage";
import LegalPage from "@/components/LegalPage";
import AiChat from "@/components/AiChat";
import CookieBanner from "@/components/CookieBanner";
import { usePageMeta } from "@/hooks/usePageMeta";

function Landing() {
  usePageMeta(
    "ConstruireMaison.net — Le guide gratuit pour construire sa maison",
    "Vidéos, simulateurs gratuits (mensualité, budget, coût au m², frais de notaire, PTZ) et guides pas à pas pour réussir la construction de votre maison : budget, terrain, permis, chantier."
  );
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Calculators />
        <Timeline />
        <Guides />
        <Marquee />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-bone text-ink font-body" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/guides/:slug" element={<GuidePage />} />
          <Route path="/mentions-legales" element={<LegalPage kind="mentions" />} />
          <Route path="/politique-de-confidentialite" element={<LegalPage kind="privacy" />} />
        </Routes>
        <AiChat />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
